import { AREA_EDIT_COLORS } from "constant/panel";
import { AreaSource } from "type/panel/Panel.type";

export const areaInitialGet = (): AreaSource => ({
  area: { columnStart: 0, columnEnd: 0, rowStart: 0, rowEnd: 0 },
  source: [],
});

export const areaFieldColorIndGet = (ind: number): string => {
  let res: string = "";
  if (ind < AREA_EDIT_COLORS.length) {
    res = AREA_EDIT_COLORS[ind];
  }
  return res;
};
